// src/features/projects/companiesApi.ts
import api from 'src/shared/api/axios';
// import type { CompanyType, ProjectCompanyRole } from './types';
import type { CompanyType, ProjectCompanyRole } from '../company/types';

export type ProjectCompanyItem = {
    id: string;
    projectId: string;
    companyId: string;
    role: ProjectCompanyRole;
    contractAmount: string | null;
    progressPercent: string | null;
    company: {
        id: string;
        name: string;
        type: CompanyType | null;
    };
    representativeMember?: {
        id: string;
        user: {
            id: string;
            email: string;
            name: string;
        };
    } | null;
};

export async function listProjectCompanies(projectId: string): Promise<ProjectCompanyItem[]> {
    const { data } = await api.get(`/projects/${projectId}/companies`);
    return data.data;
}

export async function createProjectCompany(params: {
    projectId: string;
    companyId: string;
    role: ProjectCompanyRole;
    contractAmount?: string;
    progressPercent?: string;
}): Promise<ProjectCompanyItem> {
    const { projectId, ...body } = params;
    const { data } = await api.post(`/projects/${projectId}/companies`, body);
    return data.data;
}

export async function updateProjectCompany(params: {
    projectId: string;
    id: string;
    role?: ProjectCompanyRole;
    contractAmount?: string;
    progressPercent?: string;
}): Promise<ProjectCompanyItem> {
    const { projectId, id, ...body } = params;
    const { data } = await api.patch(`/projects/${projectId}/companies/${id}`, body);
    return data.data;
}

export async function deleteProjectCompany(projectId: string, id: string) {
    await api.delete(`/projects/${projectId}/companies/${id}`);
}

export async function setProjectCompanyRepresentative(params: {
    projectId: string;
    projectCompanyId: string;
    email: string;
    name?: string;
    // projectRoleName: string;
}): Promise<ProjectCompanyItem> {
    const { projectId, projectCompanyId, ...body } = params;
    const { data } = await api.post(`/projects/${projectId}/companies/${projectCompanyId}/representative`, body);
    return data.data;
}
